import React from 'react';

import DashBoard from './pages/Dashboard';
import Passenger from './pages/Passenger';
import PassengerList from './pages/PassengerList';
import Driver from './pages/Driver';
import DriverList from './pages/DriverList';
import Schedule from './pages/Schedule';
import ScheduleList from './pages/ScheduleList';
import ScheduleListV1 from './pages/ScheduleListV1';
import Vehicle from './pages/Vehicle';
import VehicleList from './pages/VehicleList';
import PassengerView from './pages/edit/PassengerView';
import Trip from './pages/TripList';
import TripV1 from './pages/TripListV1';
import DriverEdit from './pages/edit/DriverEdit';
import VehicleEdit from './pages/edit/VehicleEdit';
//import ScheduleEdit from './pages/edit/ScheduleEdit';
import Agency from './pages/CreateAgency';
import AgencyList from './pages/AgencyList';
import AgencyEdit from './pages/edit/AgencyEdit';
import ScheduleEdit from './pages/edit/ScheduleEditNew';
import CheckList from './pages/CheckList';
import PassengerProfile from './components/profiles/PassengerProfile';
import ServiceAuthorizationList from './pages/ServiceAuthorizationList';
import AddServiceAuthorization from './pages/AddServiceAuthorization';
import EditServiceAuthorization from './pages/EditServiceAuthorization';
import ScheduleUploading from './pages/ScheduleUploading';
import ScheduleUploadHistory from './pages/ScheduleUploadHistory';
import TripPDF from './components/pdfContent/TripPDF';
import Payer from './pages/Payer';
import PayerList from './pages/PayerList';
import PayerEdit from './pages/edit/PayerEdit';
import BillingList from './pages/BillingList';
import BillingSummary from './components/BillingSummary';
import MyProfile from './pages/MyProfile';
import BillingConfiguration from './pages/BillingConfiguration';
import BillingProcessSummary from './components/BillingProcessSummary';
import BillingSummaryPage from './pages/BillingSummaryPage';
import VehicleReport from './report/VehicleReport';
import DriverProfile from './components/profiles/DriverProfile';
import DashboardNew from './pages/DashboardNew';
import UnAssignedScheduleList from './pages/UnAssignedScheduleList';
import VehicleDetails from './components/profiles/VehicleDetails';
import OfficeAdminList from './pages/OfficeAdminList';
import VehicleMaintenanceList from './report/VehicleMaintenanceList';
import Chat from './pages/Chat';
import UpdateSchedule from './pages/UpdatedSchedule';
import ScheduleEditUpdated from './pages/edit/ScheduleEditUpdated';
import BillRateConfiguration from './pages/BillRateConfiguration';
import BillRateConfigurationV1 from './pages/BillRateConfigurationV1';
import BillRateList from './pages/BillRateList';
import BillRateEdit from './pages/edit/BillRateEdit';
import SubmittedBatchList from './pages/SubmittedBatchList';
import AddTrip from './pages/AddTrip';
import AddFTPCredentials from './pages/AddFTPCredentials';
import FTPCredentialsList from './pages/FTPCredentialsList';
import AdminRoute from './components/AdminRoute';

const withAdminRoute = (Component) => {
  const AdminWrapped = () => (
    <AdminRoute>
      <Component />
    </AdminRoute>
  );
  return AdminWrapped;
};
// const DashBoard = React.lazy(() => import('./pages/Dashboard'));




const routes = [
   { path: 'dashboard', exact: true, name: 'Dashboard', component: DashBoard },
   { path: 'newdashboard', exact: true, name: 'Dashboard', component: DashboardNew },
   { path: 'passenger', exact: true, name: 'Passenger', component: Passenger },
  { path: 'passenger/list', exact: true,  name: 'Passenger List', component: PassengerList },
  { path: 'driver', exact: true,  name: 'Driver', component: ()=> <Driver roleType='driver' /> },
  { path: 'driver/list', exact: true,  name: 'Driver List', component: DriverList },
  { path: 'officeAdmin/list', exact: true,  name: 'Office Admin List', component: OfficeAdminList },
  { path: 'schedule', exact: true,  name: 'Schedule', component: Schedule },
  { path: 'schedule/list/v1', exact: true, name: 'Schedule List', component: ScheduleListV1 },
  // { path: 'schedule/list', exact: true,  name: 'Schedule List', component: ScheduleList },
  { path: 'vehicle', exact: true,  name: 'Vehicle', component: Vehicle },
  { path: 'vehicle/list', exact: true,  name: 'Vehicle', component: VehicleList },
  { path: 'passenger/edit/:id', exact: true,  name: 'Passenger Edit', component: PassengerView },
  { path: 'trip', exact: true, name: 'Add Trip', component: AddTrip },
  { path: 'trip/list', exact: true, name: 'Trip', component: Trip },
  { path: 'trip/list/v1', exact: true, name: 'Trip V1', component: TripV1 },
  { path: 'driver/edit/:id', exact: true, name: 'Driver Edit', component:()=> <DriverEdit roleType='driver' /> },
  { path: 'vehicle/edit/:id', exact: true, name: 'Vehicle Edit', component: VehicleEdit },
  // { path: 'schedule/edit/:id', exact: true, name: 'Schedule Edit', component: ScheduleEdit },
  { path: 'schedule/edit/:id', exact: true, name: 'Schedule Edit Updated', component: ScheduleEditUpdated },
  { path: 'agency', exact: true, name: 'Agency', component: Agency },
  { path: 'agency/list', exact: true, name: 'Agency List', component: AgencyList },
  { path: 'agency/edit/:id', exact: true, name: 'Agency Edit', component: AgencyEdit },
  { path: 'checking/list', exact: true, name: 'Check List', component: CheckList },
  // { path: '/passenger/profile/:id', exact: true, name: 'Passenger Profile', component: PassengerProfile },
  { path: 'schedule/upload', exact: true, name: 'Schedule Uploading', component: ScheduleUploading },
  { path: 'schedule/upload/history', exact: true, name: 'Schedule Upload History', component: ScheduleUploadHistory },
  { path: 'pdf-preview', exact: true, name: 'Trip PDF', component: TripPDF },
  { path: 'payor', exact: true, name: 'Payer', component: Payer },
  { path: 'payor/list', exact: true, name: 'Payer', component: PayerList },
  { path: 'payor/edit/:id', exact: true, name: 'Payer Edit', component: PayerEdit },
  { path: 'billing/list', exact: true, name: 'Billing', component: BillingList },
  { path: 'billing/prepare', exact: true, name: 'Billing Prepare', component: BillingSummary },
  { path: 'billing/process', exact: true, name: 'Billing Process', component: BillingProcessSummary },
  { path: 'profile/myProfile', exact: true, name: 'My Profile', component: MyProfile },
  { path: 'billing/configuration', exact: true, name: 'Bill Configuration', component: BillingConfiguration },
  { path: 'billing/summaryList', exact: true, name: 'Billing Summary', component: BillingSummaryPage },
  { path: 'vehicle/report', exact: true, name: 'Vehicle Report', component: VehicleReport },
  { path: 'driver/profile/:id', exact: true, name: 'Driver Profile', component: DriverProfile },
  { path: 'passenger/profile/:id', exact: true, name: 'Passenger Profile', component: PassengerProfile },
  { path: 'passenger/service-authorization', exact: true, name: 'Service Authorization List', component: ServiceAuthorizationList },
  { path: 'passenger/service-authorization/add', exact: true, name: 'Add Service Authorization', component: AddServiceAuthorization },
  { path: 'passenger/service-authorization/edit/:id', exact: true, name: 'Edit Service Authorization', component: EditServiceAuthorization },
  { path: 'schedule/unAssignedScheduleList', exact: true, name: 'UnAssigned Schedule List', component: UnAssignedScheduleList },
  { path: 'vehicle/view/:id', exact: true, name: 'Vehicle Details', component: VehicleDetails },
  { path: 'officeAdmin', exact: true,  name: 'Office Admin', component: ()=> <Driver roleType='officeAdmin' /> },
  { path: 'officeAdmin/edit/:id', exact: true, name: 'Driver Edit', component:()=> <DriverEdit roleType='officeAdmin' /> },
  { path: 'vehicle/maintenance/list', exact: true, name: 'Vehicle Maintenance List', component: VehicleMaintenanceList},
  { path: 'chat', exact: true, name: 'Chat', component: Chat },
  { path: 'updatedSchedule', exact: true, name: 'Update Schedule', component: UpdateSchedule },
  { path: 'billing/bill-rate-configuration', exact: true, name: 'Bill Rate Configuration', component: BillRateConfiguration },
  { path: 'billing/bill-rate-configuration/v1', exact: true, name: 'Bill Rate Configuration V1', component: BillRateConfigurationV1 },
  { path: 'billing/bill-rate-list', exact: true, name: 'Bill Rate List', component: BillRateList },
  { path: 'billing/bill-rate-edit/:id', exact: true, name: 'Bill Rate Edit', component: BillRateEdit },
  { path: 'billing/submittedBatches', exact: true, name: 'Submitted Batches List', component: SubmittedBatchList },
  { path: 'ftp/credentials', exact: true, name: 'Add FTP Credentials', component: withAdminRoute(AddFTPCredentials) },
  { path: 'ftp/credentials/list', exact: true, name: 'FTP List', component: withAdminRoute(FTPCredentialsList) },
  
  // { path: '/user', exact: true, name: 'User', component: Payer },
  //{ path: '/appliances/edit/:id', exact: true, name: 'Appliances Edit', component: AppliancesDriver }
];



export default routes;